import './bootstrap';
import { createApp, h } from 'vue';
import { createStore } from 'vuex';
import { createInertiaApp } from '@inertiajs/vue3';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import { createI18n } from 'vue-i18n';
import messages from '@/vue-i18n-locales.generated.js';
import createPersistedState from "vuex-persistedstate";

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

// Create a new store instance.
const store = createStore({
    state () {
      return {
        currentSiteLanguage: null,
        selectedLanguage: null
      }
    },
    mutations: {
      switchLanguage (state, language) {
        state.currentSiteLanguage = language;
      },
      maskAsSelected (state, selected) {
        state.selectedLanguage = selected;
      },
      clearLanguageSelection (state) {
        state.currentSiteLanguage = null;
        state.selectedLanguage = null;
      }
    },
    plugins: [createPersistedState()],
  })

const i18n = createI18n({
    legacy: false,
    locale: store.state.currentSiteLanguage ? store.state.currentSiteLanguage : 'en',
    fallbackLocale: 'en',
    messages,
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18n)
            .use(store)
            .use(ZiggyVue, Ziggy)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
